// OiAutocomplete sets its input to readonly and adds the "is-redirecting" class right
// before navigating away on a result selection (see input_style_pending() in
// @oijs/oilib). When the browser restores the page from the back/forward cache instead
// of reloading it, that pending-redirect DOM state is restored too, permanently
// disabling the input until a hard refresh. oilib has no bfcache-restore handler, so
// undo it here whenever the page is shown from cache.
window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;

    document.querySelectorAll(".oi-autocomplete").forEach(function (input) {
        input.removeAttribute("readonly");
        input.classList.remove("is-redirecting");
    });
});
